import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * An underlined "A", tinted with the text colour currently applied.
 *
 * Not MUI's FormatColorText: that glyph carries a full-width 4px bar meant to
 * read as a colour swatch, which next to FormatUnderlined looks like a second,
 * heavier underline. This reuses FormatUnderlined's own underline geometry, so
 * the two sit on the same baseline at the same weight.
 *
 * Sized in em rather than through the shared SvgIcon wrapper: Icon passes its
 * `size` down as style.fontSize, but SvgIcon reads a `size`/`fontSize` prop
 * that Icon never forwards and otherwise falls back to a hardcoded 24px — so a
 * wrapped icon renders larger than the MUI glyphs it sits beside.
 */
var TextColorLetter = function TextColorLetter(_ref) {
  var className = _ref.className,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: className,
    style: _objectSpread({
      width: '1em',
      height: '1em',
      fill: 'currentColor'
    }, style)
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z",
      transform: "translate(12,17) scale(0.92) translate(-12,-17)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 19h14v2H5z"
    })]
  }));
};
export default TextColorLetter;